"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VpcAuthenticationProvider = void 0;
var authentication_provider_1 = require("./authentication.provider");
/**
 * Authentication provider if client is used withing the private VPC of the content repository
 * @class VPCAuthenticationProvider
 */
var VpcAuthenticationProvider = /** @class */ (function () {
    function VpcAuthenticationProvider(consumerUsername, consumerUUID, aclGroups) {
        var _a;
        this.aclGroups = [];
        this.consumerUsername = consumerUsername;
        this.consumerUUID = consumerUUID ? consumerUUID : authentication_provider_1.generateUserUUIDFromUsername(consumerUsername);
        if (aclGroups) {
            (_a = this.aclGroups).push.apply(_a, aclGroups);
        }
    }
    VpcAuthenticationProvider.prototype.getAuthenticationHeaders = function () {
        return Object.assign({
            'X-Consumer-Username': this.consumerUsername,
            'X-Consumer-ID': this.consumerUUID,
        }, this.aclGroups.length ? { 'X-Consumer-Groups': this.aclGroups.join(',') } : undefined);
    };
    return VpcAuthenticationProvider;
}());
exports.VpcAuthenticationProvider = VpcAuthenticationProvider;
//# sourceMappingURL=vpc-authentication.provider.js.map